module.exports = __webpack_public_path__ + "2acb60f2/img/google.68f3823e.svg";